import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><rect width=\"18\" height=\"18\" rx=\"4\" fill=\"#F2F2F2\"></rect><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 9c0-.414.342-.75.765-.75h11.22c.423 0 .765.336.765.75s-.342.75-.765.75H3.765A.758.758 0 0 1 3 9Z\" fill=\"#184DB4\"></path></g><defs><clipPath id=\"a\"><rect width=\"18\" height=\"18\" rx=\"4\" fill=\"#fff\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };